import { OreButton, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import ico_Password from '@/Account/ui/assets/ico_Password.svg'
import { Trans, useTranslation } from 'react-i18next'
import { LoginTranslation } from '@/Account/ui/accountTranslation'
import { useLocation, useNavigate } from 'react-router-dom'
import { openNavigationRoutes } from '@/Shared/ui/routers'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const PasswordRecoveryPasswordChangeSuccess = (): JSX.Element => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const comesFromChangePasswordFlow = location.state?.fromChangePassword

  return (
    <>
      {comesFromChangePasswordFlow ? (
        <OreStack placeContent="center" space="large" style={{ paddingTop: '1rem' }}>
        <OreStack placeItems="center" space="large">
          <img src={ico_Password} alt="Success" />
          <OreStack space="medium" placeItems="center">
            <OreHeading size="headline-lg">{t(LoginTranslation.recovery.emailSent.title)}</OreHeading>
            <OreText style={{ whiteSpace: 'pre-line' }} align="center">
              <Trans t={t}>{t(LoginTranslation.recovery.passwordChangeSuccess.subtitle)}</Trans>
            </OreText>
          </OreStack>
        </OreStack>
        <OreStack placeItems="center" placeContent="center">
          <OreButton
            category="primary"
            onClick={() => navigate(openNavigationRoutes.login)}
          >
            {t(formTranslation.common.buttons.accessToWeb)}
          </OreButton>
        </OreStack>
      </OreStack>
      ) : (
        <OreText>404 Not Found</OreText>
      )}
    </>
  )
}
